var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-rox-upload-prescription"},[(_vm.isPDF)?_c('iframe',{staticClass:"rb-rox-upload-prescription__iframe",attrs:{"src":_vm.fileData}}):_c('img',{staticClass:"rb-rox-upload-prescription__image",attrs:{"src":_vm.fileData}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }